import logo from '../../assets/images/logo.png';
import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import './Header.scss';

const getAccountPath = () => {
  const role = localStorage.getItem('role');
  return role === 'partner' ? '/partner/verify' : '/dashboard';
};

const goToRide24 = (navigate) => {
  const token = localStorage.getItem('token');
  if (!token) {
    sessionStorage.setItem('postLoginRedirect', '/ride-24');
    navigate('/Login');
    return;
  }
  navigate('/ride-24');
};

const Modal = ({ isOpen, onClose, token, navigate }) => {
  if (!isOpen) return null;

  return (
    <div id="myModal" className="modal">
      <div className="modal-content">
        <span className="close" onClick={onClose}>&times;</span>
        <ul>
          <li><Link to="/">Home</Link></li>
          <li><Link to="/Events">Events</Link></li>
          <li><Link to="/Offers">Benefits</Link></li>
          {/* Hidden from public menu
          <li><Link to="/Giveaway">Giveaways</Link></li>
          */}
          <li><Link to="/">FAQs</Link></li>
          <li><Link to="/Plans">Plans</Link></li>
          <li><Link to="/Partners">Partners</Link></li>
          <li>
            <a
              href="/ride-24"
              onClick={(e) => {
                e.preventDefault();
                onClose();
                goToRide24(navigate);
              }}
            >
              Ride24
            </a>
          </li>
          {token ? (
            <li><Link to={getAccountPath()}>My Account</Link></li>
          ) : (
            <li><Link to="/Login"><span className="btn-primary">Get Started Free</span></Link></li>
          )}
        </ul>
      </div>
    </div>
  );
};

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="container-fluid fallback-old-style absolute ">
    <div className="container ">
      <div className="row-center  p-20">
         <div className="col-lg-20 col-md- col-sm-100 logo header-logo">
           <Link to="/">
             <img src={logo} alt="Taurian Home" />
           </Link>
         </div>
        
         <div className="col-lg-80 col-md-100 col-sm-100 logo">



            <ul className="hide-on-mobile">
            <li> <Link to="/">Home</Link> </li>
        <li> <Link to="/Events">Events</Link> </li>
        <li> <Link to="/Offers">Benefits</Link> </li>
        {/* Hidden from public menu
        <li> <Link to="/Giveaway">Giveaways</Link> </li>
        */}
        <li> <Link to="/Plans">Plans</Link> </li>
        <li> <Link to="/Partners">Partners</Link> </li>
        <li>
          <a
            href="/ride-24"
            onClick={(e) => {
              e.preventDefault();
              goToRide24(navigate);
            }}
          >
            Ride24
          </a>
        </li>
        {token ? (
          <li><Link to={getAccountPath()}>My Account</Link></li>
        ) : (
          <li><Link to="/Login">Login</Link></li>
        )}
       
        {/*<li><Link className="btn-primary" to="/Login">Get Started Free</Link>  </li>*/}
            </ul>

           
         
         
          

            <div className="show-on-mobile">
             
               <i className="fa fa-bars menu text-right" id="modalid"  onClick={openModal}></i>
              <Modal isOpen={isModalOpen} onClose={closeModal} token={token} navigate={navigate} />
            </div>
           
    
          
         </div>
      </div>
   </div>
  </div>
  );
}

export default Header;
